var _style, _defs, _defs2, _g, _defs3, _defs4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPsychic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_3_);}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{clip-path:url(#SVGID_7_);}\r\n\t.st3{fill:#F87C7A;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_1_",
    x1: 0,
    y1: 30,
    x2: 0,
    y2: 0
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_2_",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M106,31"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    d: "M-4,31"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Psychic",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st3",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "st4",
    d: "M6,4.6c0,0-1.8,1.4-5.3,0.8C-2,5-3.4,2.1-3.4,0.5c0-3.7,2.8-4.6,4.6-4.6C3-4,4.3-2.6,4.4-0.9 c0.1,1.4-1,2.6-2.4,2.7c0,0-0.1,0-0.1,0c-1,0.1-1.9-0.7-2-1.7c0-0.1,0-0.2,0-0.4c0-0.8,0.6-1.4,1.4-1.4c0.1,0,0.1,0,0.2,0 c0.7,0,1,0.6,1,1.2c0,0.4-0.3,0.7-0.7,0.7c0,0-0.1,0-0.1,0C1.2,0.3,1.2,0.1,1-0.1S1.2-1,0.7-1S0.1-0.2,0.1-0.2 c0.1,0.9,0.8,1.5,1.7,1.5c1.1,0.1,2-0.8,2.1-1.8c0-0.2,0-0.4,0-0.5C3.5-2.5,2-3.5,0.5-3.1c-2,0.2-2.8,2.2-2.4,4.4S1,4.6,3,4.1 s4-1.9,4-5.6S3.8-7.3,0-7s-6.2,3.7-6,7.7S-2.1,6.9,1.1,7C3,7.1,4.9,6.5,6.3,5.3c0,0,0.4-0.4,0.3-0.7S6,4.6,6,4.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.8,16.8v3.5h-2.1v-10h3.9c0.7,0,1.4,0.1,2,0.4s1,0.7,1.3,1.2s0.5,1.1,0.5,1.7c0,1-0.3,1.7-1,2.3 c-0.7,0.6-1.6,0.8-2.8,0.8H36.8z M36.8,15.1h1.8c0.5,0,1-0.1,1.2-0.4s0.4-0.6,0.4-1.1c0-0.5-0.1-0.9-0.4-1.2S39.2,12,38.7,12h-1.9 V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.9,17.7c0-0.4-0.1-0.7-0.4-0.9s-0.8-0.4-1.5-0.7c-0.7-0.2-1.3-0.5-1.7-0.7c-1.1-0.6-1.7-1.4-1.7-2.5 c0-0.5,0.2-1,0.5-1.4s0.7-0.8,1.3-1s1.2-0.4,1.9-0.4c0.7,0,1.3,0.1,1.9,0.4s1,0.6,1.3,1.1s0.5,1,0.5,1.6h-2.1 c0-0.5-0.1-0.8-0.4-1.1s-0.7-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.2,0.3s-0.4,0.5-0.4,0.8c0,0.3,0.2,0.6,0.5,0.8s0.8,0.4,1.4,0.6 c1.2,0.4,2,0.8,2.5,1.3c0.5,0.5,0.8,1.2,0.8,1.9c0,0.9-0.3,1.5-1,2s-1.5,0.7-2.6,0.7c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2 c-0.3-0.5-0.5-1.1-0.5-1.7h2.1c0,1.1,0.7,1.6,2,1.6c0.5,0,0.9-0.1,1.1-0.3S48.9,18,48.9,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.8,14.8l2.1-4.5h2.2l-3.3,6.3v3.6h-2.1v-3.6l-3.3-6.3h2.2L55.8,14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.6,17c-0.1,1.1-0.5,1.9-1.2,2.5c-0.7,0.6-1.7,0.9-2.8,0.9c-1.3,0-2.3-0.4-3-1.3c-0.7-0.9-1.1-2-1.1-3.5V15 c0-1,0.2-1.8,0.5-2.5s0.8-1.3,1.4-1.7c0.6-0.4,1.4-0.6,2.2-0.6c1.1,0,2.1,0.3,2.8,0.9s1.1,1.5,1.2,2.6h-2.1c0-0.6-0.2-1.1-0.5-1.4 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.7,0-1.2,0.2-1.5,0.7c-0.3,0.5-0.5,1.3-0.5,2.3v0.8c0,1.1,0.2,1.9,0.5,2.4c0.3,0.5,0.8,0.7,1.5,0.7 c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.3H68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.1,20.3H76V16h-4v4.3H70v-10H72v4h4v-4h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.1,20.3H80v-10h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.8,17c-0.1,1.1-0.5,1.9-1.2,2.5c-0.7,0.6-1.7,0.9-2.8,0.9c-1.3,0-2.3-0.4-3-1.3c-0.7-0.9-1.1-2-1.1-3.5V15 c0-1,0.2-1.8,0.5-2.5s0.8-1.3,1.4-1.7c0.6-0.4,1.4-0.6,2.2-0.6c1.1,0,2.1,0.3,2.8,0.9s1.1,1.5,1.2,2.6h-2.1c0-0.6-0.2-1.1-0.5-1.4 c-0.3-0.3-0.8-0.4-1.4-0.4c-0.7,0-1.2,0.2-1.5,0.7c-0.3,0.5-0.5,1.3-0.5,2.3v0.8c0,1.1,0.2,1.9,0.5,2.4c0.3,0.5,0.8,0.7,1.5,0.7 c0.6,0,1.1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.5-1.3H91.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychic);
export default __webpack_public_path__ + "static/media/psychic.16d6c7f60825502ae4496a4faed18de0.svg";
export { ForwardRef as ReactComponent };